/*
 * ******************************************************
 * Copyright (C) 1994-2021 Babiel GmbH <info@babiel.com>
 *
 * This file is part of a Babiel development
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted without the express
 * permission of Babiel GmbH
 *
 * Any modification is not permitted without the express
 * permission of Babiel GmbH
 *
 * The file may contain confidential and or privileged materials.
 * Any review, retransmission, dissemination or other use of
 * or taking of any action in reliance upon, this file
 * by persons or entities other than the intended is prohibited.
 * ******************************************************
 */

import { Component } from '../../componentSystem/component';
import { CareerWidgetComponentConfig } from './careerWidgetComponentConfig';

export class CareerWidgetComponent extends Component {
  protected readonly config: CareerWidgetComponentConfig =
    new CareerWidgetComponentConfig();

  mutationObserver: MutationObserver = new MutationObserver(
    this.filterAndHandleMutations.bind(this)
  );

  public setupEvents(): void {
    const iFrameElement = this.containerElement.querySelector('iframe');

    iFrameElement && this.handleIFrameElement(iFrameElement);

    this.mutationObserver.observe(this.containerElement, {
      childList: true,
      subtree: true,
    });
  }

  private filterAndHandleMutations(mutationRecords: MutationRecord[]): void {
    const iFrameElements = mutationRecords
      .map(
        (mutationRecord) =>
          Array.from(mutationRecord.addedNodes).filter(
            (node) => node.nodeName === 'IFRAME'
          ) as HTMLIFrameElement[]
      )
      .flat();

    iFrameElements.forEach((iFrameElement) => {
      this.handleIFrameElement(iFrameElement);
    });
  }

  private handleIFrameElement(iFrameElement: HTMLIFrameElement) {
    const { iFrameClass, loadingClass } = CareerWidgetComponentConfig;

    iFrameElement.classList.add(iFrameClass, loadingClass);

    iFrameElement.addEventListener('load', () => {
      iFrameElement.classList.remove(loadingClass);

      this.removeLoadingIndicator();
    });
  }

  private removeLoadingIndicator(): void {
    const { loadingIndicatorSelector } = CareerWidgetComponentConfig;

    const loadingIndicatorElement = this.containerElement.querySelector(
      loadingIndicatorSelector
    ) as SVGSVGElement;

    if (!loadingIndicatorElement) {
      return;
    }

    loadingIndicatorElement.remove();
  }
}
